var EPK = EPK || {};
EPK.KmPoint = EPK.KmPoint || {};

$(function() {
	// #20299 くすりの窓口ポイント
	var target_class = {
		'ProductTop': {
			'class':'madoguchipoint-baloon-box',
			'kbn' : 1
		},
		'ProductCategory': {
			'class':'madoguchipoint-info-box',
			'kbn' : 2
		},
		'ProductList': {
			'class':'madoguchipoint-info-box',
			'kbn' : 2
		},
	};

	if (target_class[EPK.common.controller]) {
		var point_baloon_box = document.getElementsByClassName(target_class[EPK.common.controller]['class']);
		if (point_baloon_box.length > 0) {
			EPK.KmPoint.setKmPoint(target_class[EPK.common.controller]['kbn']);
		}
	}
});


/**
 * くすりの窓口ポイント取得/画面へのセット
 */
EPK.KmPoint.setKmPoint = function(target_kbn) {
	// ログイン時のみ実施
	if (!EPK.common.isLogin) {
		switch (target_kbn) {
			case 1:
				$('.point-message').text('ログインしてポイントを確認する');
				$('.point-message').addClass('no-point');
				$('#km-point-link').attr('href', '/login');
				break;
			case 2:
				$('.possession-points').remove();
				var html ='<p class="login-link"><a href="/login">ログインしてポイントを確認する</a></p>';
				$('.madoguchipoint-info-box').append(html);
				break;
			default:
				break;
		}
		return true;
	}

	$.ajax({
		type: 'POST',
		url: '/api/kmpoint/summary',
		data: {},
		cache: false,
		dataType: 'json',
		timeout: 100000
	})
	.done(function(data) {
		if (data.result['status'] == 'success') {
			if (data.result['km_point']) {
				var km_point = data.result['km_point'].available_point;
				if (!km_point) {
					km_point = '0';
				}

				// ポイント残高によって表示パターン変更
				switch (target_kbn) {
					case 1:
						if (km_point > 0) {
							var html = 'くすりの窓口ポイント<span class="point-num">' + km_point.toLocaleString() + 'P</span>がすぐに使えます';
							$('#km-point-link').attr('href', '/member/kmpoint/index');
						} else {
							var html = 'すぐに使えるくすりの窓口ポイント';
							$('.baloon').unwrap();
							$('.point-message').addClass('no-point');
							$('.baloon').append('<p class="point-conf-btn"><a href="/member/kmpoint/index">0P</a></p>');
						}
						$('.point-message').append(html);
						break;
					case 2:
						$('#category-point-summary').append(km_point.toLocaleString() + 'P');
						break;
					default:
						break;
				}
			}
		} else {
			switch (target_kbn) {
				case 1:
					var html = 'すぐに使えるくすりの窓口ポイント<span class="point-num">0</span>';
					$('.point-message').append(html);
					break;
				case 2:
					$('.point-message').append('0P');
					break;
				default:
					break;
			}
			console.log('kmPoint summary data is empty');
			return false;
		}
		return true;
	}).fail(function(data) {
		console.log('failed');
		console.log(data);
		return false;
	});
};
